<template>
    <bottom-sheet v-model="shows" title="지원정보" fullscreen persistent width="1080" maxWidth="95%" needsLogin>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, loading }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <template v-if="loading">
                <v-overlay absolute color="white">
                    <v-progress-circular indeterminate size="100" width="5" color="primary" />
                </v-overlay>
            </template>
            <template v-else>
                <div class="text-center mb-20 mb-lg-40">
                    <h3 class="tit">지원정보</h3>
                </div>
                <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                    <resume-personal-information :value="employee.resume" mode="view" />
                    <resume-name :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-education :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-work-experience :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-hash-tags :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-languages :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-office-skills :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-certifications :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                    <resume-cover-letter :value="employee.resume" mode="view" class="mt-30 mt-lg-60" />
                </v-sheet>
            </template>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import { initExpoEmployee } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";

import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";

export default {
    components: {
        BottomSheet,
        ResumeCertifications,
        ResumeCoverLetter,
        ResumeEducation,
        ResumeHashTags,
        ResumeLanguages,
        ResumeName,
        ResumeOfficeSkills,
        ResumePersonalInformation,
        ResumeWorkExperience,
    },
    props: {
        _program: { type: String, default: null },
        _employee: { type: String, default: null },
    },
    data: () => ({
        employee: initExpoEmployee(),

        shows: false,
        loading: false,
    }),
    computed: {
        ...mapGetters(["_user"]),
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { _program, _employee } = this;
                const { employee } = await api.v1.expo.programs.employees.get({
                    _id: _employee,
                    _program,
                });

                if (employee.resume?.personalInformation?.bornAt) employee.resume.personalInformation.bornAt = employee.resume.personalInformation.bornAt.toDate();
                for (const item of employee.resume?.education?.otherEducations || []) {
                    item.tempId = Math.random();
                }
                for (const item of employee.resume?.workExperience?.list || []) {
                    item.tempId = Math.random();
                    if (item?.duration?.startsAt) item.duration.startsAt = item.duration.startsAt.toDate();
                    if (item?.duration?.endsAt) item.duration.endsAt = item.duration.endsAt.toDate();
                }

                this.employee = initExpoEmployee(employee);
            } finally {
                this.loading = false;
            }
        },
        async exit() {
            this.shows = false;
        },
    },
    watch: {
        _employee() {
            this.init();
        },
        _program() {
            this.init();
        },
        _user() {
            this.init();
        },
        shows(shows) {
            if (shows) this.$nextTick(this.init);
        },
    },
    mounted() {
        this.init();
    },
};
</script>
